import Component from './MarketingNotifierWithContext.svelte';
import { reactify } from 'svelte-preprocess-react';
const MarketingNotifier = reactify(Component);

export default MarketingNotifier;
